export default __webpack_public_path__ + "static/media/remove.b4062541.svg";